import { render, staticRenderFns } from "./TutorEditTabInformation.vue?vue&type=template&id=4ae191c6&"
import script from "./TutorEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./TutorEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./TutorEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports